import React, { memo, useState, useEffect } from "react";
import { Input, Button } from "antd";
let counts = 60;
let timer = null;

const Vcode = (props) => {
  const [message, setMessage] = useState("重新发送(60s)");
  const [isGetCode, setGetCode] = useState(true);
  const [vcode, setVcode] = useState("");

  useEffect(() => {
    // setMessage("重新发送(60s)");
    setGetCode(true);
    timer = setInterval(() => {
      setMessage(`重新发送(${counts}s)`);
    }, 1000);
    return () => {
      clearInterval(timer);
      counts = 60
    };
  }, []);

  useEffect(() => {
    if (counts === 0) {
      clearInterval(timer);
      setMessage("获取验证码");
      setGetCode(false);
      counts = 60
    } else {
      counts--;
    }
    return () => {
    };
  }, [message]);

  const sendCode = () => {
    props.sendAgain()
    // setMessage("重新发送(60s)");
    setGetCode(true);
    timer = setInterval(() => {
      setMessage(`重新发送(${counts}s)`);
    }, 1000);
  }

  return (
    <>
      <div className="row" style={{ fontSize: 16, marginBottom: 15 }}>
        <label>手机号码:</label>
        <span style={{ marginLeft: 6 }}>{props.phone}</span>
      </div>
      <div className="row" style={{ fontSize: 16, marginBottom: 15 }}>
        <label>验证码:</label>
        <Input
          placeholder="请输入验证码"
          style={{ width: 240, margin: "0 24px" }}
          value={vcode}
          onChange={(e) => {
            setVcode(e.target.value);
            props.setVcode(e.target.value);
          }}
        />
        <Button
          type="defalut"
          disabled={isGetCode}
          className={isGetCode ? "" : "vcodeButton"}
          onClick={sendCode}
        >
          {message}
        </Button>
      </div>
    </>
  );
};

export default memo(Vcode);
